import { EventInput } from '@/services/BaseInput'

export const INPUT_TYPES = {
  DESCRIPTION: 'DESCRIPTION',
  TITLE: 'TITLE',
  SUBTITLE: 'SUBTITLE',
  TEXT: 'TEXT',
  TEXTAREA: 'TEXTAREA',
  SELECT: 'SELECT',
  AUTOCOMPLETE: 'AUTOCOMPLETE',
  CHECKBOOK: 'CHECKBOX',
  RADIO: 'RADIO',
  SWITCHTOGGLE: 'SWITCHTOGGLE',
  DATE: 'DATE',
  TIME: 'TIME',
  GROUP: 'GROUP',
}

export interface IOption {
  text?: string
  value: any
  header?: string
  subHeader?: string
  disabled?: boolean
  readonly?: boolean
  divider?: boolean
  icon?: string
}

export interface IGroup {
  fields: IFormOption[]
}

export interface IFormOption {
  type: string
  component?: any
  description?: string
  className?: string
  col?: string
  isHide?: boolean
  children?: IFormOption[]
  props?: {
    rules?: any
    className?: string
    name?: string
    transform?: (event: EventInput | any, oldValue: any) => any
    options?: IOption[] | IGroup[] | any[]
    direction?: { row?: boolean, column?: boolean } // radio
    defaultValue?: any
    label?: string
    title?: string
    type?: string
    placeholder?: string
    parent?: string
    maxlength?: string
    disabled?: boolean
    readonly?: boolean
    multiple?: boolean
    isActive?: boolean
    isLoading?: boolean
    returnObject?: boolean
    height?: number
    width?: number
    allowDate?: (value: any) => any
    prefix?: string
    suffix?: string
    dense?: boolean
    loading?: boolean
    validateOnBlur?: boolean
    on?: {
      [key: string]: (value?: any, name?: string) => void,
    }
    [key: string]: any,
  }
}
